import { createAction, props } from '@ngrx/store';
import { AddressState, PersonDetailsState } from './offer.state';
import { ContractDuration, Level, Price, SupplementaryInsurancePrices } from '../../api';

export const resetOfferState = createAction('[Offer] Reset offer state');

export const addPerson = createAction('[Offer] Add person to offer', props<{ details: PersonDetailsState }>());

export const removePerson = createAction('[Offer] Remove person from offer', props<{ personId: number }>());

export const updatePerson = createAction(
  '[Offer] Update person from offer',
  props<{ personId: number; details: PersonDetailsState }>(),
);

export const removeOfferForPerson = createAction('[Offer] Remove offer for person', props<{ personId: number }>());

export const updateOfferDetails = createAction(
  '[Offer] Update Offer details',
  props<{
    address: AddressState;
    saleOfferBegin: string;
    existingCustomer: boolean;
  }>(),
);

export const calculateOfferSuccess = createAction(
  '[Offer] Calculate offer success',
  props<{
    persons: {
      basicInsurancePrice: Price;
      supplementaryInsurancePrices: SupplementaryInsurancePrices;
      totalPrice: number;
    }[];
    totalPrice: number;
  }>(),
);

export const changeContractDuration = createAction(
  '[Offer] Update contract duration on offer',
  props<{
    contractDuration: ContractDuration;
  }>(),
);

export const changeIsExistingCustomer = createAction(
  '[Offer] Update is existing customer on offer',
  props<{
    existingCustomer: boolean;
  }>(),
);

export const changeSaleOfferBegin = createAction(
  '[Offer] Update sale offer begin',
  props<{
    saleOfferBegin: string;
  }>(),
);

export const changeOfferAddress = createAction(
  '[Offer] Update address of offer',
  props<{
    address: AddressState;
  }>(),
);

export const addFrameworkContract = createAction(
  '[Offer] Add framework contract to offer',
  props<{
    number: string;
    name: string;
    syriusKey: { contractNumber: string; personGroupShortDescription: string };
  }>(),
);

export const selectYouthPackage = createAction(
  '[Offer] Select youth package for person',
  props<{
    level: Level;
    personId: number;
  }>(),
);
export const deselectYouthPackage = createAction(
  '[Offer] Deselect youth package for person',
  props<{
    personId: number;
  }>(),
);

export const addTupCustomer = createAction('[Offer] Add TUP customer to offer');

export const removeFrameworkContract = createAction('[Offer] Remove framework contract in offer');

export const selectFrameworkContractOnSummaryPage = createAction('[Offer] Select framework contract on summary page');
